import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"

interface DeleteCompanyDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  companyName: string
}

export function DeleteCompanyDialog({
  isOpen,
  onClose,
  onConfirm,
  companyName,
}: DeleteCompanyDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Firma Silme İşlemi</DialogTitle>
          <DialogDescription>
            <p><strong>{companyName}</strong> firmasını silmek üzeresiniz.</p>
            <p className="mt-2">Bu işlem:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Firmanın tüm verilerini kalıcı olarak siler</li>
              <li>Firma yöneticilerinin hesaplarını devre dışı bırakır</li>
              <li>Müzik sistemlerinin bağlantısını keser</li>
              <li>Tüm istatistik ve raporları kaldırır</li>
            </ul>
            <p className="mt-4 text-destructive font-semibold">
              Bu işlem geri alınamaz! Devam etmek istediğinizden emin misiniz?
            </p>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            İptal
          </Button>
          <Button
            variant="destructive"
            onClick={() => {
              onConfirm()
              onClose()
            }}
          >
            Firmayı Sil
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
